/**
 * leaderboard-config.js — isolated frontend config for the leaderboard.
 *
 * Everything the leaderboard panel needs in one place:
 *   - which models to show per provider
 *   - score display precision
 *   - bar colors for the chart
 *
 * The score metric is now hardcoded on the backend. The frontend only
 * receives raw score numbers and rounds them for display.
 *
 * To pin a different model per provider, edit LEADERBOARD_MODELS.
 * To change score decimal places, edit SCORE_PRECISION.
 */

// ── Pinned models (provider → model_name) ──────────────────────
// These are the "strongest" / featured models shown on the leaderboard.
export const LEADERBOARD_MODELS = {
  DeepSeek: 'deepseek-v4-pro',
  Kimi: 'kimi-k2.6',
  Alibaba: 'qwen3.7-max',
  Zhipu: 'glm-5.1',
  OpenAI: 'gpt-5.5',
  Anthropic: 'claude-opus-4.8',
  Google: 'gemini-3.1-pro',
};

// ── Score display precision ────────────────────────────────────
// Number of decimal places to show when displaying scores.
// The backend sends raw scores; the frontend rounds using this value.
export const SCORE_PRECISION = 4;

// ── Chart colours ──────────────────────────────────────────────
export const BAR_COLORS = [
  '#f97316', '#fb923c', '#fdba74', '#facc15',
  '#f59e0b', '#38bdf8', '#22c55e', '#94a3b8',
];
